// Project + deliverable metadata — mirrors server validators. Post-021
// 8-active + 2-terminal status list (item 2.1) + 4-deliverable type list
// (item 2.4 media-bucket consolidation).

export const PROJECT_STATUSES = [
  'intake', 'media_capture', 'build', 'preview_review',
  'approved', 'domain_cutover', 'live', 'maintained',
  'canceled', 'on_hold',
];

export const PROJECT_TRANSITIONS = {
  intake:         ['media_capture', 'build', 'on_hold', 'canceled'],
  media_capture:  ['build', 'on_hold', 'canceled'],
  build:          ['preview_review', 'media_capture', 'on_hold', 'canceled'],
  preview_review: ['approved', 'build', 'on_hold', 'canceled'],
  approved:       ['domain_cutover', 'preview_review', 'on_hold', 'canceled'],
  domain_cutover: ['live', 'approved', 'on_hold', 'canceled'],
  live:           ['maintained', 'canceled'],
  maintained:     ['canceled'],
  canceled:       [],
  on_hold:        PROJECT_STATUSES.filter((s) => s !== 'on_hold'),
};

export const PROJECT_STATUS_META = {
  intake:         { label: 'Intake',          tone: 'bg-gray-500/10 text-gray-300 border-gray-500/20' },
  media_capture:  { label: 'Media capture',   tone: 'bg-blue-500/10 text-blue-300 border-blue-500/20' },
  build:          { label: 'Build',           tone: 'bg-cyan-500/10 text-cyan-300 border-cyan-500/20' },
  preview_review: { label: 'Preview review',  tone: 'bg-amber-500/10 text-amber-300 border-amber-500/20' },
  approved:       { label: 'Approved',        tone: 'bg-lime-500/10 text-lime-300 border-lime-500/20' },
  domain_cutover: { label: 'Domain cutover',  tone: 'bg-sky-500/10 text-sky-300 border-sky-500/20' },
  live:           { label: 'Live',            tone: 'bg-emerald-500/10 text-emerald-300 border-emerald-500/20' },
  maintained:     { label: 'Maintained',      tone: 'bg-green-500/10 text-green-300 border-green-500/20' },
  canceled:       { label: 'Canceled',        tone: 'bg-red-500/10 text-red-300 border-red-500/20' },
  on_hold:        { label: 'On hold',         tone: 'bg-gray-500/10 text-gray-500 border-gray-500/20' },
  // Deprecated — kept so historical project_status_history rows still render
  // a label when shown in timelines.
  content_collection: { label: 'Content collection', tone: 'bg-gray-500/10 text-gray-400 border-gray-500/20' },
  design:             { label: 'Design',             tone: 'bg-gray-500/10 text-gray-400 border-gray-500/20' },
  internal_review:    { label: 'Internal review',    tone: 'bg-gray-500/10 text-gray-400 border-gray-500/20' },
  preview_sent:       { label: 'Preview sent',       tone: 'bg-gray-500/10 text-gray-400 border-gray-500/20' },
  client_reviewing:   { label: 'Client reviewing',   tone: 'bg-gray-500/10 text-gray-400 border-gray-500/20' },
  revisions:          { label: 'Revisions',          tone: 'bg-gray-500/10 text-gray-400 border-gray-500/20' },
};

export function projectStatusMeta(s) {
  return PROJECT_STATUS_META[s] || { label: s || '—', tone: 'bg-gray-500/10 text-gray-400 border-gray-500/20' };
}

// Active stages shown as Kanban columns (item 2.3). Excludes terminal states.
export const PROJECT_KANBAN_COLUMNS = [
  'intake', 'media_capture', 'build', 'preview_review',
  'approved', 'domain_cutover', 'live', 'maintained',
];

export const DELIVERABLE_TYPE_META = {
  site_build:          { label: 'Site build',          icon: 'code' },
  media_capture:       { label: 'Media capture',       icon: 'camera' },
  accessibility_audit: { label: 'Accessibility audit', icon: 'shield-check' },
  domain_cutover:      { label: 'Domain cutover',      icon: 'globe' },
};

export const DELIVERABLE_STATUS_META = {
  not_started:    { label: 'Not started',    tone: 'bg-gray-500/10 text-gray-400 border-gray-500/20' },
  in_progress:    { label: 'In progress',    tone: 'bg-cyan-500/10 text-cyan-300 border-cyan-500/20' },
  blocked:        { label: 'Blocked',        tone: 'bg-orange-500/10 text-orange-300 border-orange-500/20' },
  delivered:      { label: 'Delivered',      tone: 'bg-emerald-500/10 text-emerald-300 border-emerald-500/20' },
  not_applicable: { label: 'N/A',            tone: 'bg-gray-500/10 text-gray-500 border-gray-500/20' },
};

export function deliverableStatusMeta(s) {
  return DELIVERABLE_STATUS_META[s] || { label: s || '—', tone: 'bg-gray-500/10 text-gray-400 border-gray-500/20' };
}

export const DELIVERABLE_TRANSITIONS = {
  not_started:    ['in_progress', 'blocked', 'not_applicable'],
  in_progress:    ['blocked', 'delivered', 'not_applicable'],
  blocked:        ['not_started', 'in_progress', 'delivered', 'not_applicable'],
  delivered:      ['in_progress'],
  not_applicable: ['not_started'],
};

export function validDeliverableTransitions(current) {
  return DELIVERABLE_TRANSITIONS[current] || [];
}
